/* ===== Shenbai Global JS ===== */
/* Synced from HTML pages - Core interactions for all pages */
(function() {
    'use strict';

    // ===== Scroll Animations (IntersectionObserver) =====
    function observeElements() {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

        document.querySelectorAll('.fade-up, .fade-left, .fade-right').forEach(function(el) {
            if (!el.classList.contains('visible')) {
                observer.observe(el);
            }
        });
    }
    observeElements();

    // Re-observe on DOM changes (for Shopify section editor)
    var mutationObserver = new MutationObserver(function() {
        observeElements();
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    // ===== Counter Animation =====
    function animateCounters() {
        document.querySelectorAll('.counter').forEach(function(counter) {
            var target = parseInt(counter.dataset.target);
            var duration = 2000;
            var start = 0;
            var startTime = performance.now();

            function updateCounter(currentTime) {
                var elapsed = currentTime - startTime;
                var progress = Math.min(elapsed / duration, 1);
                var eased = 1 - Math.pow(1 - progress, 3);
                var current = Math.floor(start + (target - start) * eased);
                counter.textContent = current.toLocaleString();
                if (progress < 1) {
                    requestAnimationFrame(updateCounter);
                } else {
                    counter.textContent = target.toLocaleString();
                }
            }
            requestAnimationFrame(updateCounter);
        });
    }

    var statsObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                animateCounters();
                statsObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.3 });

    var statsBanner = document.querySelector('.stats-banner');
    if (statsBanner) statsObserver.observe(statsBanner);

    // ===== Navbar Scroll Effect =====
    var navbar = document.getElementById('navbar');
    function handleNavScroll() {
        if (navbar) {
            if (window.scrollY > 80) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        }
    }
    window.addEventListener('scroll', handleNavScroll);
    handleNavScroll();

    // ===== Hamburger Menu =====
    var hamburger = document.getElementById('hamburger');
    var navMenu = document.getElementById('navMenu');
    if (hamburger && navMenu) {
        hamburger.addEventListener('click', function() {
            this.classList.toggle('active');
            navMenu.classList.toggle('active');
        });
    }

    // Mobile dropdown toggle
    document.querySelectorAll('.nav-dropdown .dropdown-toggle').forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
            if (window.innerWidth <= 768) {
                e.preventDefault();
                this.closest('.nav-dropdown').classList.toggle('open');
            }
        });
    });

    // ===== Hero Parallax =====
    window.addEventListener('scroll', function() {
        var hero = document.querySelector('.hero-bg');
        if (hero) {
            var scrolled = window.scrollY;
            if (scrolled < window.innerHeight) {
                hero.style.transform = 'translateY(' + (scrolled * 0.3) + 'px)';
            }
        }
    });

    // ===== Smooth Scroll for Anchor Links =====
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            var href = this.getAttribute('href');
            if (href === '#' || href.length < 2) return;
            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                var headerHeight = document.querySelector('.header-wrapper')
                    ? document.querySelector('.header-wrapper').offsetHeight
                    : 0;
                var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
        });
    });

})();
